import { render, staticRenderFns } from "./ManageTax.vue?vue&type=template&id=54ca1c13"
import script from "./ManageTax.vue?vue&type=script&lang=js"
export * from "./ManageTax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports